import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";

const DooleysBanner = () => {
    const { clientAssetsLink } = useClientConfig();

    return (
        <div className="center bnr-img">
            <div className="owl-carousel owl-theme home_slider slick-initialized slick-slider">
                <div aria-live="polite" className="slick-list draggable">
                    <div className="slick-track" role="listbox">
                        <div className="slide_slider_inner one slick-slide slick-current slick-active" data-slick-index={0} aria-hidden="false" tabIndex={-1} role="option" aria-describedby="slick-slide00">
                            <img src={clientAssetsLink + "/banner.jpg"} />
                            <div className="overlay" />
                            <h1>CAREERS AT DOOLEYS</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DooleysBanner;